import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Salon } from '../../models/salon/salon.model';
import { Country } from '../../models/country/country.model';
import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';
import { CountryService } from '../../services/country.service';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { LoadingController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'smr-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.scss'],
})
export class MailingAddressComponent  implements OnInit {
  public submitted: boolean;
  public isLoading: boolean;
  public errorOccurredWhileLoadingCountries: boolean;
  public salon: Salon;
  public salonProfileForm: FormGroup;
  public address1: FormControl;
  public address2: FormControl;
  public city: FormControl;
  public province: FormControl;
  public postal: FormControl;
  public country: FormControl;
  public countries: List<Country>;

  public isAdmin: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private countryService: CountryService,
    public loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private userService: UserService,
    private salonService: SalonService,
    public alertService: AlertService,
    public toastService: ToastService,
    private router: Router
  ) {
    this.salon = userService.getSalon().clone();
     this.isAdmin = this.userService.getUser().isAdministrator();
     this.isLoading = false;
     this.submitted = false;
    this.address1 = new FormControl(this.salon.getAddress1(), Validators.maxLength(40));
    this.address2 = new FormControl(this.salon.getAddress2(), Validators.maxLength(40));
    this.city = new FormControl(this.salon.getCity(), Validators.maxLength(20));
    this.province = new FormControl(this.salon.getProvince(), Validators.maxLength(25));
    this.postal = new FormControl(this.salon.getPostal(), Validators.maxLength(7));
    this.country = new FormControl((this.salon.getCountry()) ? this.salon.getCountry().getID() : null);

    this.salonProfileForm = this.formBuilder.group({
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal: this.postal,
      country: this.country,
    })
  }

  ngOnInit() {
    this.loadCountries();
  }

  public loadCountries () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingCountries = false;
    this.countryService.getCountries()
      .subscribe({
          next: (countries) => {
            this.countries = countries;
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.errorOccurredWhileLoadingCountries = true;
          },
          complete: () => console.info('Fetched all countries')
      });
  }
  public async onSalonProfileSave () {
    this.submitted = true;

    if (this.salonProfileForm.valid === false) {
      return;
    }

    let newCountry: Country;
    this.countries
      .filter((country: Country) => country.getID() === this.country.value)
      .map((country: Country) => {
        newCountry = country;
      });

    this.salon = this.salon.setAddress1(this.address1.value);
    this.salon = this.salon.setAddress2(this.address2.value);
    this.salon = this.salon.setCity(this.city.value);
    this.salon = this.salon.setProvince(this.province.value);
    this.salon = this.salon.setPostal(this.postal.value);
    this.salon = this.salon.setCountry(newCountry);
  
    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });
    loader.present();
    this.salonService.saveSalon(this.salon)
      .subscribe({
        next: (result) => {
          this.salon = result;
          this.submitted = false;
          this.userService.setSalon(this.salon);
          this.toastService.presentSimpleToast(`Salon profile has been successfully updated.`, 3000);

          loader.dismiss().then(() => {
              // Not sure why we do this - why would we have a modal here?
              this.modalCtrl.dismiss(this.salon);
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.alertService.presentErrorAlert();
          });
        }      
      });
  }

  public onDismiss() {
    this.modalCtrl.dismiss()
    this.router.navigateByUrl('/bookings')
  }
}
